class Keys {
  static sidebarStatusKey = 'vue3-typescript-admin-sidebarStatusKey'
  static languageKey = 'vue3-typescript-admin-languageKey'
  static sizeKey = 'vue3-typescript-admin-sizeKey'
  static tokenKey = 'access-token'
  static aseKey = 'vue3-typescript-admin-ase-key'
}

export default Keys
